/* eslint-disable react-hooks/rules-of-hooks */
import React, { useMemo } from 'react';
import { BoxExtendedProps, costFormater, Enrollment, InvestmentCard, Preloader } from '@common-fe/common-fe';

import { useInvestmentsHoldings } from '../hooks';

interface Props extends BoxExtendedProps {
  enrollment: Enrollment;
  children?: React.ReactNode;
}
const InvestmentCardSellBlock: React.FC<Props> = ({ enrollment, children, ...rest }) => {
  if (!enrollment) {
    return null;
  }
  const {
    details: { portfolioBalance = 0 },
    isHoldingLoading,
    formattedByCategory,
  } = useInvestmentsHoldings(enrollment?.id);

  const currentType = useMemo(() => {
    return enrollment.accountType;
  }, [enrollment]);

  if (isHoldingLoading) {
    return <Preloader />;
  }
  return (
    <InvestmentCard {...rest} type={currentType}>
      <InvestmentCard.Icon type={currentType} />
      <InvestmentCard.Title>Investments</InvestmentCard.Title>
      {children ? (
        children
      ) : (
        <InvestmentCard.Item>
          <InvestmentCard.Item.Text>Investment portfolio balance</InvestmentCard.Item.Text>
          <InvestmentCard.Item.Amount>
            {costFormater(portfolioBalance, {
              isOptionalPrecision: true,
            })}
          </InvestmentCard.Item.Amount>
        </InvestmentCard.Item>
      )}
      {formattedByCategory?.length && <InvestmentCard.Bar data={formattedByCategory} />}
    </InvestmentCard>
  );
};

export default InvestmentCardSellBlock;
